const primarySocials = [
  { label: "Instagram", href: "https://www.instagram.com/kewordal" },
  { label: "Facebook", href: "https://www.facebook.com/kewordal" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/kewordal" },
  { label: "YouTube", href: "https://www.youtube.com/@kewordalchannel" },
  { label: "TikTok", href: "https://www.tiktok.com/@kewordal" },
  { label: "Pinterest", href: "https://www.pinterest.co.uk/kewordal" },
  { label: "X (Twitter)", href: "https://www.twitter.com/kewordal" },
];

const renderSocialLink = ({ label, href }) => (
  <a
    key={label}
    title={label}
    aria-label={label}
    href={href}
    target="_blank"
    rel="noreferrer"
    className="link"
  >
    {label}
  </a>
);

const SocialLinks = () => {
  return (
    <div className="footer-section social-links">
      <p className="footer-heading">Follow Us</p>

      <div className="social-list">{primarySocials.map(renderSocialLink)}</div>
    </div>
  );
};

export default SocialLinks;
